import _ from 'lodash';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  isLoading: false,
  isGroupMembershipListFetched: false,
  groupMembershipList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_GROUP_MEMBERSHIP.SUCCESS: {
      const { resultData = {}, message="" } = action.payload;
      return {
        ...state,
        isLoading: false,
        isGroupMembershipListFetched: true,
        groupMembershipList: resultData
      };
    }
    case actionTypes.GET_GROUP_MEMBERSHIP.PENDING: {
      return {
        ...state,
        isLoading: true
      };
    }
    case actionTypes.CLEAR_GROUP_MEMBERSHIP_DATA: {
      return {
        ...INITIAL_STATE
      };
    }
    default:
      return state;
  }
};
